import React, { useState } from 'react';
import { Box, ClickAwayListener, Typography } from '@mui/material';
import { InfoWindowF, MarkerF } from '@react-google-maps/api';
import styles from './styles';

export interface UniversityMarkerProps {
  universityPosition: { lat: number; lng: number };
  universityName?: string;
}

function UniversityMarker({
  universityPosition,
  universityName
}: UniversityMarkerProps) {
  const [isCardOpen, setIsCardOpen] = useState(false);

  const handleClickAway = () => {
    if (isCardOpen) {
      setIsCardOpen(false);
    }
  };

  const handleCenterClick = () => {
    if (!isCardOpen) {
      setIsCardOpen(true);
    } else {
      setIsCardOpen(false);
    }
  };

  return (
    <MarkerF
      position={universityPosition as unknown as google.maps.LatLng}
      key="universityDetailPin"
      icon={{
        url: '/mapImages/schoolBlue.png',
        scaledSize: new window.google.maps.Size(40, 50)
      }}
      onClick={() => handleCenterClick()}
      title="University Marker"
    >
      {!isCardOpen ? null : (
        <InfoWindowF
          position={universityPosition as unknown as google.maps.LatLng}
          zIndex={4}
          options={{
            pixelOffset: new window.google.maps.Size(-5, 8)
          }}
        >
          <ClickAwayListener onClickAway={handleClickAway}>
            <Box sx={styles.universityInfo}>
              <Typography sx={styles.universityName}>
                {universityName}
              </Typography>
            </Box>
          </ClickAwayListener>
        </InfoWindowF>
      )}
    </MarkerF>
  );
}

export default UniversityMarker;
